import { Category, SlideShowItem, MenuItem, ContactInfo, SocialLink, Provider, UserCenterProfile } from '../types';

export const categories: Category[] = [
  { id: 'textil', name: 'Textil', icon: 'fas fa-tshirt', href: '/textil' },
  { id: 'muebles', name: 'Muebles & Deco', icon: 'fas fa-couch', href: '/proveedores' },
  { id: 'herrerias', name: 'Herrerias', icon: 'fas fa-hammer', href: '/proveedores' },
  { id: 'griferia', name: 'Griferia', icon: 'fas fa-faucet', href: '/proveedores' },
  { id: 'ferreteria', name: 'Ferreteria', icon: 'fas fa-tools', href: '/proveedores' },
  { id: 'aberturas', name: 'Aberturas', icon: 'fas fa-door-open', href: '/proveedores' },
  { id: 'maquinaria', name: 'Maquinaria', icon: 'fas fa-truck-monster', href: '/proveedores' },
  { id: 'herramientas', name: 'Herramientas', icon: 'fas fa-wrench', href: '/proveedores' },
  { id: 'arquitectos', name: 'Arquitectos', icon: 'fas fa-ruler-combined', href: '/proveedores' },
  { id: 'mm-obra', name: 'M.M de Obra', icon: 'fas fa-hard-hat', href: '/proveedores' },
  { id: 'gestores', name: 'Gestores', icon: 'fas fa-users', href: '/proveedores' },
  { id: 'constructoras', name: 'Constructoras', icon: 'fas fa-building', href: '/proveedores' },
];

export const slideShowItems: SlideShowItem[] = [
  {
    id: 1,
    image: 'https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Encontrá todo lo que necesitás para tu proyecto acá'
  },
  {
    id: 2,
    image: 'https://images.pexels.com/photos/1463917/pexels-photo-1463917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Encontrá todo lo que necesitás para tu proyecto acá'
  },
  {
    id: 3,
    image: 'https://images.pexels.com/photos/2098624/pexels-photo-2098624.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Encontrá todo lo que necesitás para tu proyecto acá'
  }
];

export const menuItems: MenuItem[] = [
  { id: 'inicio', label: 'Inicio', href: '/' },      
  { id: 'obra-ai', label: 'OBRA AI', href: '/obra-ai' },
  { id: 'faq', label: 'FAQ', href: '/faq' },
];

export const contactInfo: ContactInfo[] = [
  {
    label: 'Para Soporte de Alquiler',
    content: '+54 9 11 3310-2465',
    icon: '/assets/img/icons/ico-phone24.svg',
    link: 'tel:+5491133102465'
  },
  {
    label: 'Horario de Oficina',
    content: 'Lun - Sáb 8am to 6pm',
    icon: '/assets/img/icons/ico-timer.svg'
  },
  {
    label: 'Envíanos un Email',
    content: 'rentals@my-domain.net',
    icon: '/assets/img/icons/ico-mail.svg',
    link: 'mailto:rentals@my-domain.net'
  }
];

export const socialLinks: SocialLink[] = [
  { platform: 'Twitter', href: '#!', icon: 'fab fa-twitter' },
  { platform: 'Facebook', href: '#!', icon: 'fab fa-facebook-f' },
  { platform: 'Google Plus', href: '#!', icon: 'fab fa-google-plus-g' },
  { platform: 'YouTube', href: '#!', icon: 'fab fa-youtube' },
  { platform: 'Pinterest', href: '#!', icon: 'fab fa-pinterest-p' },
];

export const provinces = [
  'Capital Federal',
  'Gran Buenos Aires',
  'Pcia. Buenos Aires',
  'Catamarca',
  'Córdoba',
  'Corrientes',
  'Chaco',
  'Chubut',
  'Entre Ríos',
  'Formosa',
  'Jujuy',
  'La Pampa',
  'La Rioja',
  'Mendoza',
  'Misiones',
  'Neuquén',
  'Río Negro',
  'Salta',
  'San Juan',
  'San Luis',
  'Santa Cruz',
  'Santa Fe',
  'Santiago del Estero',
  'Tierra del Fuego',
  'Tucumán'
];

export const activityTypes = [
  'Fabricación',
  'Distribución',
  'Comercio Minorista',
  'Comercio Mayorista',
  'Servicios',
  'Construcción',
  'Agro/Cultivos/Ganadería',
  'Otros'
];

export const howDidYouKnow = [
  'Google',
  'Otros Buscadores',
  'Por Recomendación',
  'Publicidad',
  'Exposiciones',
  'Otros',
  'Avisos en Televisión'
];

export const providers: Provider[] = [
  // HERRERIAS
  {
    id: 'herreria-industrial-sur',
    name: 'Herrería Industrial del Sur',
    description: 'Especialistas en estructuras metálicas y herrería industrial',
    category: 'herrerias',
    rating: 4.9,
    reviewCount: 127,
    phone: '+54 11 1234-5678',
    email: 'herreriasur@industrial.com',
    website: 'https://herreriasur.com',
    address: 'Av. Industrial 1234',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Estructuras metálicas', 'Herrería industrial', 'Soldadura', 'Carpintería metálica'],
    specialties: ['Estructuras para galpones', 'Escaleras metálicas', 'Barandas'],
    yearsOfExperience: 15,
    certifications: ['ISO 9001', 'Soldador certificado'],
    isVerified: true,
    isPremium: true,
    responseTime: '2 horas',
    minPrice: '$50.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'metalurgica-norte',
    name: 'Metalúrgica del Norte',
    description: 'Fabricación y reparación de estructuras metálicas',
    category: 'herrerias',
    rating: 4.7,
    reviewCount: 89,
    phone: '+54 11 2345-6789',
    email: 'info@metalurgicanorte.com',
    address: 'Ruta 9 Km 45',
    city: 'San Isidro',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Fabricación metálica', 'Reparaciones', 'Mantenimiento'],
    specialties: ['Puertas metálicas', 'Ventanas', 'Portones'],
    yearsOfExperience: 12,
    certifications: ['Normas IRAM'],
    isVerified: true,
    isPremium: false,
    responseTime: '4 horas',
    minPrice: '$30.000',
    maxPrice: '$300.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 17:00',
      tuesday: '7:00 - 17:00',
      wednesday: '7:00 - 17:00',
      thursday: '7:00 - 17:00',
      friday: '7:00 - 17:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'herreria-express',
    name: 'Herrería Express',
    description: 'Servicio rápido de herrería y soldadura',
    category: 'herrerias',
    rating: 4.5,
    reviewCount: 67,
    phone: '+54 11 3456-7890',
    email: 'express@herreria.com',
    address: 'Zona Oeste - Morón',
    city: 'Morón',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Soldadura', 'Reparaciones rápidas', 'Herrería general'],
    specialties: ['Reparaciones de emergencia', 'Soldadura en sitio'],
    yearsOfExperience: 8,
    certifications: ['Soldador certificado'],
    isVerified: true,
    isPremium: false,
    responseTime: '1 hora',
    minPrice: '$15.000',
    maxPrice: '$150.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 20:00',
      tuesday: '8:00 - 20:00',
      wednesday: '8:00 - 20:00',
      thursday: '8:00 - 20:00',
      friday: '8:00 - 20:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'metalurgica-norte',
    name: 'Metalúrgica del Norte',
    description: 'Fabricación y reparación de estructuras metálicas',
    category: 'herrerias',
    rating: 4.7,
    reviewCount: 89,
    phone: '+54 11 2345-6789',
    email: 'info@metalurgicanorte.com',
    address: 'Ruta 9 Km 45',
    city: 'San Isidro',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Fabricación metálica', 'Reparaciones', 'Mantenimiento'],
    specialties: ['Puertas metálicas', 'Ventanas', 'Portones'],
    yearsOfExperience: 12,
    certifications: ['Normas IRAM'],
    isVerified: true,
    isPremium: false,
    responseTime: '4 horas',
    minPrice: '$30.000',
    maxPrice: '$300.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 17:00',
      tuesday: '7:00 - 17:00',
      wednesday: '7:00 - 17:00',
      thursday: '7:00 - 17:00',
      friday: '7:00 - 17:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },

  // ARQUITECTOS
  {
    id: 'estudio-arquitectura-moderna',
    name: 'Estudio de Arquitectura Moderna',
    description: 'Diseño arquitectónico innovador y sustentable',
    category: 'arquitectos',
    rating: 4.8,
    reviewCount: 156,
    phone: '+54 11 3456-7890',
    email: 'contacto@estudiomoderno.com',
    website: 'https://estudiomoderno.com',
    address: 'Av. Corrientes 1234',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Diseño arquitectónico', 'Proyectos residenciales', 'Proyectos comerciales'],
    specialties: ['Arquitectura sustentable', 'Interiorismo', 'Urbanismo'],
    yearsOfExperience: 20,
    certifications: ['Colegio de Arquitectos', 'LEED Certified'],
    isVerified: true,
    isPremium: true,
    responseTime: '1 hora',
    minPrice: '$100.000',
    maxPrice: '$2.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés', 'Francés'],
    paymentMethods: ['Transferencia', 'Tarjeta', 'Cheque'],
    workingHours: {
      monday: '9:00 - 19:00',
      tuesday: '9:00 - 19:00',
      wednesday: '9:00 - 19:00',
      thursday: '9:00 - 19:00',
      friday: '9:00 - 19:00',
      saturday: '10:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'arquitectura-sustentable',
    name: 'Arquitectura Sustentable & Diseño',
    description: 'Especialistas en arquitectura verde y diseño bioclimático',
    category: 'arquitectos',
    rating: 4.9,
    reviewCount: 98,
    phone: '+54 11 4567-8901',
    email: 'info@arquitecturasustentable.com',
    website: 'https://arquitecturasustentable.com',
    address: 'Palermo - Buenos Aires',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Arquitectura sustentable', 'Diseño bioclimático', 'Certificaciones LEED'],
    specialties: ['Casas pasivas', 'Energía renovable', 'Materiales ecológicos'],
    yearsOfExperience: 15,
    certifications: ['LEED AP', 'Colegio de Arquitectos'],
    isVerified: true,
    isPremium: true,
    responseTime: '2 horas',
    minPrice: '$150.000',
    maxPrice: '$3.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 13:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'estudio-interiorismo',
    name: 'Estudio de Interiorismo & Arquitectura',
    description: 'Diseño de interiores y arquitectura residencial',
    category: 'arquitectos',
    rating: 4.6,
    reviewCount: 134,
    phone: '+54 11 5678-9012',
    email: 'contacto@estudiointeriorismo.com',
    address: 'Recoleta - Buenos Aires',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Interiorismo', 'Arquitectura residencial', 'Diseño de espacios'],
    specialties: ['Diseño de cocinas', 'Dormitorios', 'Living rooms'],
    yearsOfExperience: 12,
    certifications: ['Colegio de Arquitectos'],
    isVerified: true,
    isPremium: false,
    responseTime: '24 horas',
    minPrice: '$80.000',
    maxPrice: '$1.500.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '10:00 - 19:00',
      tuesday: '10:00 - 19:00',
      wednesday: '10:00 - 19:00',
      thursday: '10:00 - 19:00',
      friday: '10:00 - 19:00',
      saturday: '10:00 - 15:00',
      sunday: 'Cerrado'
    }
  },

  // PLOMEROS
  {
    id: 'plomeria-express',
    name: 'Plomería Express 24hs',
    description: 'Servicio de plomería de emergencia las 24 horas',
    category: 'griferia',
    rating: 4.6,
    reviewCount: 234,
    phone: '+54 11 4567-8901',
    email: 'emergencias@plomeriaexpress.com',
    address: 'Zona de cobertura: CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop&crop=center',
    services: ['Reparaciones de emergencia', 'Instalaciones', 'Mantenimiento'],
    specialties: ['Fugas de agua', 'Desatascos', 'Instalación de calefones'],
    yearsOfExperience: 8,
    certifications: ['Matrícula habilitante'],
    isVerified: true,
    isPremium: true,
    responseTime: '30 minutos',
    minPrice: '$5.000',
    maxPrice: '$50.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Mercado Pago'],
    workingHours: {
      monday: '24 horas',
      tuesday: '24 horas',
      wednesday: '24 horas',
      thursday: '24 horas',
      friday: '24 horas',
      saturday: '24 horas',
      sunday: '24 horas'
    }
  },
  {
    id: 'plomeria-profesional',
    name: 'Plomería Profesional del Norte',
    description: 'Servicios profesionales de plomería y gas',
    category: 'griferia',
    rating: 4.8,
    reviewCount: 156,
    phone: '+54 11 5678-9012',
    email: 'info@plomeriaprofesional.com',
    address: 'Zona Norte - San Isidro y Vicente López',
    city: 'San Isidro',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop&crop=center',
    services: ['Plomería residencial', 'Instalaciones de gas', 'Mantenimiento'],
    specialties: ['Instalaciones nuevas', 'Reparaciones complejas', 'Certificaciones'],
    yearsOfExperience: 18,
    certifications: ['Matrícula habilitante', 'Gasista matriculado'],
    isVerified: true,
    isPremium: true,
    responseTime: '2 horas',
    minPrice: '$8.000',
    maxPrice: '$100.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '7:00 - 19:00',
      tuesday: '7:00 - 19:00',
      wednesday: '7:00 - 19:00',
      thursday: '7:00 - 19:00',
      friday: '7:00 - 19:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'plomeria-rapida',
    name: 'Plomería Rápida & Eficiente',
    description: 'Soluciones rápidas para problemas de plomería',
    category: 'griferia',
    rating: 4.4,
    reviewCount: 89,
    phone: '+54 11 6789-0123',
    email: 'rapida@plomeria.com',
    address: 'Zona Oeste - Morón y alrededores',
    city: 'Morón',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop&crop=center',
    services: ['Reparaciones rápidas', 'Desatascos', 'Instalaciones simples'],
    specialties: ['Desatascos urgentes', 'Reparación de caños', 'Instalación de grifería'],
    yearsOfExperience: 10,
    certifications: ['Matrícula habilitante'],
    isVerified: true,
    isPremium: false,
    responseTime: '1 hora',
    minPrice: '$3.000',
    maxPrice: '$30.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 20:00',
      tuesday: '8:00 - 20:00',
      wednesday: '8:00 - 20:00',
      thursday: '8:00 - 20:00',
      friday: '8:00 - 20:00',
      saturday: '8:00 - 18:00',
      sunday: 'Emergencias'
    }
  },

  // ELECTRICISTAS
  {
    id: 'electricidad-segura',
    name: 'Electricidad Segura',
    description: 'Instalaciones eléctricas certificadas y seguras',
    category: 'herramientas',
    rating: 4.9,
    reviewCount: 189,
    phone: '+54 11 5678-9012',
    email: 'info@electricidadsegura.com',
    address: 'Cobertura en toda la provincia',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=300&fit=crop&crop=center',
    services: ['Instalaciones eléctricas', 'Reparaciones', 'Certificaciones'],
    specialties: ['Instalaciones industriales', 'Automatización', 'Iluminación LED'],
    yearsOfExperience: 18,
    certifications: ['Matrícula profesional', 'Normas IRAM'],
    isVerified: true,
    isPremium: true,
    responseTime: '2 horas',
    minPrice: '$8.000',
    maxPrice: '$150.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '7:00 - 20:00',
      tuesday: '7:00 - 20:00',
      wednesday: '7:00 - 20:00',
      thursday: '7:00 - 20:00',
      friday: '7:00 - 20:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'electricidad-industrial',
    name: 'Electricidad Industrial & Comercial',
    description: 'Especialistas en instalaciones eléctricas industriales',
    category: 'herramientas',
    rating: 4.7,
    reviewCount: 145,
    phone: '+54 11 6789-0123',
    email: 'industrial@electricidad.com',
    address: 'Zona Industrial - Pilar',
    city: 'Pilar',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=300&fit=crop&crop=center',
    services: ['Instalaciones industriales', 'Mantenimiento preventivo', 'Automatización'],
    specialties: ['Tableros eléctricos', 'Motores industriales', 'Control de procesos'],
    yearsOfExperience: 22,
    certifications: ['Matrícula profesional', 'Normas IRAM', 'ISO 9001'],
    isVerified: true,
    isPremium: true,
    responseTime: '4 horas',
    minPrice: '$15.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Transferencia', 'Tarjeta', 'Cheque'],
    workingHours: {
      monday: '6:00 - 18:00',
      tuesday: '6:00 - 18:00',
      wednesday: '6:00 - 18:00',
      thursday: '6:00 - 18:00',
      friday: '6:00 - 18:00',
      saturday: '6:00 - 12:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'electricidad-residencial',
    name: 'Electricidad Residencial Express',
    description: 'Servicios eléctricos para hogares y pequeños comercios',
    category: 'herramientas',
    rating: 4.5,
    reviewCount: 112,
    phone: '+54 11 7890-1234',
    email: 'residencial@electricidad.com',
    address: 'Cobertura en CABA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=300&fit=crop&crop=center',
    services: ['Instalaciones residenciales', 'Reparaciones', 'Iluminación'],
    specialties: ['Instalación de aires acondicionados', 'Iluminación LED', 'Reparación de electrodomésticos'],
    yearsOfExperience: 12,
    certifications: ['Matrícula profesional'],
    isVerified: true,
    isPremium: false,
    responseTime: '3 horas',
    minPrice: '$5.000',
    maxPrice: '$80.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Emergencias'
    }
  },

  // ALBAÑILES
  {
    id: 'construcciones-garcia',
    name: 'Construcciones García',
    description: 'Albañilería y construcción en general',
    category: 'mm-obra',
    rating: 4.5,
    reviewCount: 145,
    phone: '+54 11 6789-0123',
    email: 'garcia@construcciones.com',
    address: 'Zona Norte - San Isidro y Vicente López',
    city: 'San Isidro',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop&crop=center',
    services: ['Albañilería', 'Construcción', 'Refacciones'],
    specialties: ['Pisos y revestimientos', 'Mampostería', 'Hormigón'],
    yearsOfExperience: 25,
    certifications: ['Registro de constructores'],
    isVerified: true,
    isPremium: false,
    responseTime: '24 horas',
    minPrice: '$15.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 17:00',
      tuesday: '7:00 - 17:00',
      wednesday: '7:00 - 17:00',
      thursday: '7:00 - 17:00',
      friday: '7:00 - 17:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'albañileria-pro',
    name: 'Albañilería Profesional',
    description: 'Servicios profesionales de albañilería y construcción',
    category: 'mm-obra',
    rating: 4.8,
    reviewCount: 178,
    phone: '+54 11 7890-1234',
    email: 'pro@albañileria.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop&crop=center',
    services: ['Albañilería profesional', 'Construcción en seco', 'Refacciones'],
    specialties: ['Construcción en seco', 'Revestimientos', 'Pisos flotantes'],
    yearsOfExperience: 20,
    certifications: ['Registro de constructores', 'Certificación en construcción en seco'],
    isVerified: true,
    isPremium: true,
    responseTime: '48 horas',
    minPrice: '$20.000',
    maxPrice: '$800.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '7:00 - 18:00',
      tuesday: '7:00 - 18:00',
      wednesday: '7:00 - 18:00',
      thursday: '7:00 - 18:00',
      friday: '7:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'construcciones-rapidas',
    name: 'Construcciones Rápidas & Eficientes',
    description: 'Soluciones rápidas para construcción y refacciones',
    category: 'mm-obra',
    rating: 4.3,
    reviewCount: 92,
    phone: '+54 11 8901-2345',
    email: 'rapidas@construcciones.com',
    address: 'Zona Oeste - Morón y alrededores',
    city: 'Morón',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop&crop=center',
    services: ['Refacciones rápidas', 'Albañilería general', 'Reparaciones'],
    specialties: ['Reparaciones de emergencia', 'Pintura', 'Pequeñas refacciones'],
    yearsOfExperience: 15,
    certifications: ['Registro de constructores'],
    isVerified: true,
    isPremium: false,
    responseTime: '12 horas',
    minPrice: '$8.000',
    maxPrice: '$200.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },

  // PINTORES
  {
    id: 'pinturas-pro',
    name: 'Pinturas Pro',
    description: 'Servicio profesional de pintura y decoración',
    category: 'ferreteria',
    rating: 4.7,
    reviewCount: 98,
    phone: '+54 11 7890-1234',
    email: 'info@pinturaspro.com',
    address: 'Cobertura en CABA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&h=300&fit=crop&crop=center',
    services: ['Pintura interior y exterior', 'Decoración', 'Texturas'],
    specialties: ['Pintura de interiores', 'Fachadas', 'Texturas decorativas'],
    yearsOfExperience: 12,
    certifications: ['Certificación técnica'],
    isVerified: true,
    isPremium: true,
    responseTime: '6 horas',
    minPrice: '$12.000',
    maxPrice: '$200.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'pintura-decorativa',
    name: 'Pintura Decorativa & Artística',
    description: 'Especialistas en pintura decorativa y texturas artísticas',
    category: 'ferreteria',
    rating: 4.9,
    reviewCount: 76,
    phone: '+54 11 8901-2345',
    email: 'decorativa@pintura.com',
    address: 'Palermo - Buenos Aires',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&h=300&fit=crop&crop=center',
    services: ['Pintura decorativa', 'Texturas artísticas', 'Murales'],
    specialties: ['Faux finish', 'Texturas venecianas', 'Murales personalizados'],
    yearsOfExperience: 18,
    certifications: ['Certificación en pintura decorativa'],
    isVerified: true,
    isPremium: true,
    responseTime: '24 horas',
    minPrice: '$25.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 15:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'pintura-express',
    name: 'Pintura Express & Rápida',
    description: 'Servicio rápido de pintura para hogares y oficinas',
    category: 'ferreteria',
    rating: 4.4,
    reviewCount: 134,
    phone: '+54 11 9012-3456',
    email: 'express@pintura.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&h=300&fit=crop&crop=center',
    services: ['Pintura rápida', 'Pintura de interiores', 'Pintura de exteriores'],
    specialties: ['Pintura de habitaciones', 'Pintura de oficinas', 'Pintura de fachadas'],
    yearsOfExperience: 10,
    certifications: ['Certificación técnica'],
    isVerified: true,
    isPremium: false,
    responseTime: '2 horas',
    minPrice: '$8.000',
    maxPrice: '$150.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '7:00 - 19:00',
      tuesday: '7:00 - 19:00',
      wednesday: '7:00 - 19:00',
      thursday: '7:00 - 19:00',
      friday: '7:00 - 19:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },

  // CARPINTEROS
  {
    id: 'carpinteria-artesanal',
    name: 'Carpintería Artesanal',
    description: 'Muebles a medida y carpintería de obra',
    category: 'muebles',
    rating: 4.8,
    reviewCount: 167,
    phone: '+54 11 8901-2345',
    email: 'artesanal@carpinteria.com',
    website: 'https://carpinteriaartesanal.com',
    address: 'Taller en Palermo',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop&crop=center',
    services: ['Muebles a medida', 'Carpintería de obra', 'Restauración'],
    specialties: ['Muebles de cocina', 'Closets', 'Puertas y ventanas'],
    yearsOfExperience: 30,
    certifications: ['Cámara de carpinteros'],
    isVerified: true,
    isPremium: true,
    responseTime: '48 horas',
    minPrice: '$25.000',
    maxPrice: '$800.000',
    availability: 'busy',
    languages: ['Español', 'Italiano'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'carpinteria-moderna',
    name: 'Carpintería Moderna & Diseño',
    description: 'Carpintería moderna con diseños contemporáneos',
    category: 'muebles',
    rating: 4.6,
    reviewCount: 98,
    phone: '+54 11 9012-3456',
    email: 'moderna@carpinteria.com',
    address: 'Recoleta - Buenos Aires',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop&crop=center',
    services: ['Carpintería moderna', 'Diseño de muebles', 'Carpintería de obra'],
    specialties: ['Muebles minimalistas', 'Cocinas modernas', 'Dormitorios'],
    yearsOfExperience: 15,
    certifications: ['Cámara de carpinteros'],
    isVerified: true,
    isPremium: true,
    responseTime: '72 horas',
    minPrice: '$30.000',
    maxPrice: '$1.200.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 13:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'carpinteria-rapida',
    name: 'Carpintería Rápida & Reparaciones',
    description: 'Servicios rápidos de carpintería y reparaciones',
    category: 'muebles',
    rating: 4.3,
    reviewCount: 145,
    phone: '+54 11 0123-4567',
    email: 'rapida@carpinteria.com',
    address: 'Zona Oeste - Morón',
    city: 'Morón',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop&crop=center',
    services: ['Reparaciones rápidas', 'Carpintería general', 'Instalación de muebles'],
    specialties: ['Reparación de muebles', 'Instalación de puertas', 'Ajustes rápidos'],
    yearsOfExperience: 12,
    certifications: ['Cámara de carpinteros'],
    isVerified: true,
    isPremium: false,
    responseTime: '24 horas',
    minPrice: '$8.000',
    maxPrice: '$200.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Emergencias'
    }
  },

  // JARDINEROS
  {
    id: 'jardineria-verde',
    name: 'Jardinería Verde',
    description: 'Diseño y mantenimiento de jardines',
    category: 'ferreteria',
    rating: 4.6,
    reviewCount: 134,
    phone: '+54 11 9012-3456',
    email: 'verde@jardineria.com',
    address: 'Zona Oeste - Morón y alrededores',
    city: 'Morón',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop&crop=center',
    services: ['Diseño de jardines', 'Mantenimiento', 'Poda'],
    specialties: ['Jardines verticales', 'Paisajismo', 'Riego automático'],
    yearsOfExperience: 15,
    certifications: ['Técnico en jardinería'],
    isVerified: true,
    isPremium: false,
    responseTime: '24 horas',
    minPrice: '$8.000',
    maxPrice: '$100.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 17:00',
      tuesday: '7:00 - 17:00',
      wednesday: '7:00 - 17:00',
      thursday: '7:00 - 17:00',
      friday: '7:00 - 17:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'paisajismo-pro',
    name: 'Paisajismo Profesional',
    description: 'Diseño de paisajes y jardines de autor',
    category: 'ferreteria',
    rating: 4.9,
    reviewCount: 89,
    phone: '+54 11 1234-5678',
    email: 'pro@paisajismo.com',
    address: 'Zona Norte - San Isidro',
    city: 'San Isidro',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop&crop=center',
    services: ['Diseño de paisajes', 'Jardines de autor', 'Mantenimiento premium'],
    specialties: ['Jardines japoneses', 'Jardines tropicales', 'Diseño sustentable'],
    yearsOfExperience: 20,
    certifications: ['Paisajista certificado', 'Diseño de jardines'],
    isVerified: true,
    isPremium: true,
    responseTime: '48 horas',
    minPrice: '$25.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'jardineria-express',
    name: 'Jardinería Express & Mantenimiento',
    description: 'Servicios rápidos de jardinería y mantenimiento',
    category: 'ferreteria',
    rating: 4.4,
    reviewCount: 156,
    phone: '+54 11 2345-6789',
    email: 'express@jardineria.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop&crop=center',
    services: ['Mantenimiento de jardines', 'Poda', 'Riego'],
    specialties: ['Poda de árboles', 'Mantenimiento de césped', 'Riego automático'],
    yearsOfExperience: 10,
    certifications: ['Técnico en jardinería'],
    isVerified: true,
    isPremium: false,
    responseTime: '12 horas',
    minPrice: '$5.000',
    maxPrice: '$80.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '7:00 - 18:00',
      tuesday: '7:00 - 18:00',
      wednesday: '7:00 - 18:00',
      thursday: '7:00 - 18:00',
      friday: '7:00 - 18:00',
      saturday: '7:00 - 16:00',
      sunday: 'Emergencias'
    }
  },

  // GASISTAS
  {
    id: 'gas-instalaciones',
    name: 'Gas Instalaciones Seguras',
    description: 'Instalaciones de gas certificadas y seguras',
    category: 'griferia',
    rating: 4.9,
    reviewCount: 201,
    phone: '+54 11 0123-4567',
    email: 'seguro@gasinstalaciones.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop&crop=center',
    services: ['Instalaciones de gas', 'Reparaciones', 'Certificaciones'],
    specialties: ['Instalaciones domiciliarias', 'Calefones', 'Cocinas'],
    yearsOfExperience: 22,
    certifications: ['Matrícula de gasista', 'Normas IRAM'],
    isVerified: true,
    isPremium: true,
    responseTime: '3 horas',
    minPrice: '$10.000',
    maxPrice: '$80.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 20:00',
      tuesday: '8:00 - 20:00',
      wednesday: '8:00 - 20:00',
      thursday: '8:00 - 20:00',
      friday: '8:00 - 20:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'gas-express-24hs',
    name: 'Gas Express 24hs',
    description: 'Servicio de gas de emergencia las 24 horas',
    category: 'griferia',
    rating: 4.7,
    reviewCount: 167,
    phone: '+54 11 3456-7890',
    email: 'emergencias@gasexpress.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop&crop=center',
    services: ['Emergencias de gas', 'Reparaciones urgentes', 'Instalaciones'],
    specialties: ['Fugas de gas', 'Reparación de calefones', 'Instalación de cocinas'],
    yearsOfExperience: 15,
    certifications: ['Matrícula de gasista', 'Normas IRAM'],
    isVerified: true,
    isPremium: true,
    responseTime: '30 minutos',
    minPrice: '$8.000',
    maxPrice: '$60.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '24 horas',
      tuesday: '24 horas',
      wednesday: '24 horas',
      thursday: '24 horas',
      friday: '24 horas',
      saturday: '24 horas',
      sunday: '24 horas'
    }
  },
  {
    id: 'gas-profesional',
    name: 'Gas Profesional & Certificaciones',
    description: 'Servicios profesionales de gas con certificaciones',
    category: 'griferia',
    rating: 4.8,
    reviewCount: 134,
    phone: '+54 11 4567-8901',
    email: 'profesional@gas.com',
    address: 'Zona Norte - San Isidro',
    city: 'San Isidro',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop&crop=center',
    services: ['Instalaciones profesionales', 'Certificaciones', 'Mantenimiento'],
    specialties: ['Instalaciones industriales', 'Certificaciones IRAM', 'Mantenimiento preventivo'],
    yearsOfExperience: 25,
    certifications: ['Matrícula de gasista', 'Normas IRAM', 'ISO 9001'],
    isVerified: true,
    isPremium: true,
    responseTime: '4 horas',
    minPrice: '$15.000',
    maxPrice: '$150.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '7:00 - 19:00',
      tuesday: '7:00 - 19:00',
      wednesday: '7:00 - 19:00',
      thursday: '7:00 - 19:00',
      friday: '7:00 - 19:00',
      saturday: '8:00 - 16:00',
      sunday: 'Emergencias'
    }
  },

  // LIMPIEZA
  {
    id: 'limpieza-total',
    name: 'Limpieza Total',
    description: 'Servicios de limpieza residencial y comercial',
    category: 'ferreteria',
    rating: 4.4,
    reviewCount: 89,
    phone: '+54 11 1234-5678',
    email: 'total@limpieza.com',
    address: 'Servicio en toda la ciudad',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop&crop=center',
    services: ['Limpieza residencial', 'Limpieza comercial', 'Limpieza post-obra'],
    specialties: ['Limpieza de alfombras', 'Limpieza de vidrios', 'Desinfección'],
    yearsOfExperience: 8,
    certifications: ['Certificación en limpieza'],
    isVerified: true,
    isPremium: false,
    responseTime: '24 horas',
    minPrice: '$3.000',
    maxPrice: '$50.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 19:00',
      tuesday: '7:00 - 19:00',
      wednesday: '7:00 - 19:00',
      thursday: '7:00 - 19:00',
      friday: '7:00 - 19:00',
      saturday: '8:00 - 16:00',
      sunday: '8:00 - 14:00'
    }
  },
  {
    id: 'limpieza-profesional',
    name: 'Limpieza Profesional & Corporativa',
    description: 'Servicios de limpieza profesional para empresas',
    category: 'ferreteria',
    rating: 4.8,
    reviewCount: 145,
    phone: '+54 11 2345-6789',
    email: 'profesional@limpieza.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop&crop=center',
    services: ['Limpieza corporativa', 'Limpieza de oficinas', 'Mantenimiento'],
    specialties: ['Limpieza de edificios corporativos', 'Mantenimiento de espacios', 'Limpieza especializada'],
    yearsOfExperience: 15,
    certifications: ['ISO 9001', 'Certificación en limpieza profesional'],
    isVerified: true,
    isPremium: true,
    responseTime: '48 horas',
    minPrice: '$10.000',
    maxPrice: '$200.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Transferencia', 'Tarjeta', 'Cheque'],
    workingHours: {
      monday: '6:00 - 22:00',
      tuesday: '6:00 - 22:00',
      wednesday: '6:00 - 22:00',
      thursday: '6:00 - 22:00',
      friday: '6:00 - 22:00',
      saturday: '6:00 - 18:00',
      sunday: '6:00 - 14:00'
    }
  },
  {
    id: 'limpieza-express',
    name: 'Limpieza Express & Rápida',
    description: 'Servicios rápidos de limpieza para hogares',
    category: 'ferreteria',
    rating: 4.5,
    reviewCount: 178,
    phone: '+54 11 3456-7890',
    email: 'express@limpieza.com',
    address: 'Cobertura en CABA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop&crop=center',
    services: ['Limpieza rápida', 'Limpieza de hogares', 'Limpieza de emergencia'],
    specialties: ['Limpieza de departamentos', 'Limpieza post-mudanza', 'Limpieza de fin de semana'],
    yearsOfExperience: 10,
    certifications: ['Certificación en limpieza'],
    isVerified: true,
    isPremium: false,
    responseTime: '2 horas',
    minPrice: '$5.000',
    maxPrice: '$80.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '7:00 - 20:00',
      tuesday: '7:00 - 20:00',
      wednesday: '7:00 - 20:00',
      thursday: '7:00 - 20:00',
      friday: '7:00 - 20:00',
      saturday: '7:00 - 18:00',
      sunday: '8:00 - 16:00'
    }
  },
  
  // FERRETERIA
  {
    id: 'ferreteria-industrial',
    name: 'Ferretería Industrial del Sur',
    description: 'Ferretería industrial y herramientas profesionales',
    category: 'ferreteria',
    rating: 4.7,
    reviewCount: 234,
    phone: '+54 11 4567-8901',
    email: 'industrial@ferreteria.com',
    website: 'https://ferreteriaindustrial.com',
    address: 'Av. Industrial 2345',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Venta de herramientas', 'Ferretería industrial', 'Asesoramiento técnico'],
    specialties: ['Herramientas eléctricas', 'Ferretería industrial', 'Equipos de seguridad'],
    yearsOfExperience: 25,
    certifications: ['Distribuidor autorizado', 'ISO 9001'],
    isVerified: true,
    isPremium: true,
    responseTime: '1 hora',
    minPrice: '$1.000',
    maxPrice: '$50.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '7:00 - 18:00',
      tuesday: '7:00 - 18:00',
      wednesday: '7:00 - 18:00',
      thursday: '7:00 - 18:00',
      friday: '7:00 - 18:00',
      saturday: '7:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'ferreteria-express',
    name: 'Ferretería Express 24hs',
    description: 'Ferretería de emergencia las 24 horas',
    category: 'ferreteria',
    rating: 4.5,
    reviewCount: 156,
    phone: '+54 11 5678-9012',
    email: 'express@ferreteria.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Venta de herramientas', 'Ferretería general', 'Entrega rápida'],
    specialties: ['Herramientas de emergencia', 'Ferretería básica', 'Entrega en sitio'],
    yearsOfExperience: 12,
    certifications: ['Distribuidor autorizado'],
    isVerified: true,
    isPremium: false,
    responseTime: '30 minutos',
    minPrice: '$500',
    maxPrice: '$20.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '24 horas',
      tuesday: '24 horas',
      wednesday: '24 horas',
      thursday: '24 horas',
      friday: '24 horas',
      saturday: '24 horas',
      sunday: '24 horas'
    }
  },
  
  // ABERTURAS
  {
    id: 'aberturas-modernas',
    name: 'Aberturas Modernas & Diseño',
    description: 'Aberturas modernas y diseño personalizado',
    category: 'aberturas',
    rating: 4.8,
    reviewCount: 189,
    phone: '+54 11 6789-0123',
    email: 'modernas@aberturas.com',
    website: 'https://aberturasmodernas.com',
    address: 'Showroom en Palermo',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Venta de aberturas', 'Instalación', 'Diseño personalizado'],
    specialties: ['Ventanas de aluminio', 'Puertas de entrada', 'Aberturas de PVC'],
    yearsOfExperience: 18,
    certifications: ['Distribuidor autorizado', 'Instalador certificado'],
    isVerified: true,
    isPremium: true,
    responseTime: '24 horas',
    minPrice: '$50.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'aberturas-rapidas',
    name: 'Aberturas Rápidas & Reparaciones',
    description: 'Reparación y mantenimiento de aberturas',
    category: 'aberturas',
    rating: 4.4,
    reviewCount: 134,
    phone: '+54 11 7890-1234',
    email: 'rapidas@aberturas.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Reparación de aberturas', 'Mantenimiento', 'Instalación'],
    specialties: ['Reparación de ventanas', 'Cambio de burletes', 'Ajuste de puertas'],
    yearsOfExperience: 15,
    certifications: ['Instalador certificado'],
    isVerified: true,
    isPremium: false,
    responseTime: '4 horas',
    minPrice: '$8.000',
    maxPrice: '$100.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'aberturas-premium',
    name: 'Aberturas Premium & Exclusivas',
    description: 'Aberturas de alta gama y diseño exclusivo',
    category: 'aberturas',
    rating: 4.9,
    reviewCount: 245,
    phone: '+54 11 8901-2345',
    email: 'premium@aberturas.com',
    website: 'https://aberturaspremium.com',
    address: 'Showroom en Recoleta',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Aberturas premium', 'Diseño exclusivo', 'Instalación premium'],
    specialties: ['Ventanas de madera', 'Puertas blindadas', 'Aberturas inteligentes'],
    yearsOfExperience: 25,
    certifications: ['Distribuidor premium', 'Instalador certificado'],
    isVerified: true,
    isPremium: true,
    responseTime: '12 horas',
    minPrice: '$150.000',
    maxPrice: '$2.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés', 'Italiano'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '10:00 - 19:00',
      tuesday: '10:00 - 19:00',
      wednesday: '10:00 - 19:00',
      thursday: '10:00 - 19:00',
      friday: '10:00 - 19:00',
      saturday: '10:00 - 16:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'aberturas-express',
    name: 'Aberturas Express 24hs',
    description: 'Servicio de emergencia para aberturas las 24 horas',
    category: 'aberturas',
    rating: 4.6,
    reviewCount: 178,
    phone: '+54 11 9012-3456',
    email: 'express@aberturas.com',
    address: 'Cobertura en CABA y GBA',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Emergencias 24hs', 'Reparaciones urgentes', 'Instalación rápida'],
    specialties: ['Reparación de emergencia', 'Cambio de cerraduras', 'Ajustes urgentes'],
    yearsOfExperience: 12,
    certifications: ['Instalador certificado'],
    isVerified: true,
    isPremium: false,
    responseTime: '1 hora',
    minPrice: '$15.000',
    maxPrice: '$200.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '24 horas',
      tuesday: '24 horas',
      wednesday: '24 horas',
      thursday: '24 horas',
      friday: '24 horas',
      saturday: '24 horas',
      sunday: '24 horas'
    }
  },
  {
    id: 'aberturas-sustentables',
    name: 'Aberturas Sustentables & Ecológicas',
    description: 'Aberturas con materiales ecológicos y eficiencia energética',
    category: 'aberturas',
    rating: 4.7,
    reviewCount: 156,
    phone: '+54 11 0123-4567',
    email: 'sustentables@aberturas.com',
    website: 'https://aberturassustentables.com',
    address: 'Showroom en Palermo',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Aberturas sustentables', 'Eficiencia energética', 'Materiales ecológicos'],
    specialties: ['Doble vidrio hermético', 'Aberturas de madera certificada', 'Sistemas de aislación'],
    yearsOfExperience: 18,
    certifications: ['Certificación LEED', 'Instalador certificado'],
    isVerified: true,
    isPremium: true,
    responseTime: '48 horas',
    minPrice: '$80.000',
    maxPrice: '$800.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'aberturas-clasicas',
    name: 'Aberturas Clásicas & Tradicionales',
    description: 'Aberturas con estilo clásico y tradicional',
    category: 'aberturas',
    rating: 4.5,
    reviewCount: 98,
    phone: '+54 11 1234-5678',
    email: 'clasicas@aberturas.com',
    address: 'Taller en San Telmo',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Aberturas clásicas', 'Restauración', 'Reproducción de modelos antiguos'],
    specialties: ['Ventanas francesas', 'Puertas de época', 'Restauración de aberturas'],
    yearsOfExperience: 30,
    certifications: ['Artesano certificado', 'Restaurador'],
    isVerified: true,
    isPremium: false,
    responseTime: '72 horas',
    minPrice: '$30.000',
    maxPrice: '$500.000',
    availability: 'available',
    languages: ['Español', 'Italiano'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '8:00 - 17:00',
      tuesday: '8:00 - 17:00',
      wednesday: '8:00 - 17:00',
      thursday: '8:00 - 17:00',
      friday: '8:00 - 17:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  // Proveedores para categoría TEXTIL
  {
    id: 'textil-premium',
    name: 'Textil Premium & Diseño',
    description: 'Telas y materiales textiles de alta calidad para decoración',
    category: 'textil',
    rating: 4.8,
    reviewCount: 203,
    phone: '+54 11 4567-8901',
    email: 'premium@textil.com',
    website: 'https://textilpremium.com',
    address: 'Showroom en Recoleta',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop&crop=center',
    services: ['Telas premium', 'Cortinas personalizadas', 'Tapicería'],
    specialties: ['Seda natural', 'Lino premium', 'Algodón egipcio'],
    yearsOfExperience: 15,
    certifications: ['Certificación de calidad textil'],
    isVerified: true,
    isPremium: true,
    responseTime: '24 horas',
    minPrice: '$5.000',
    maxPrice: '$150.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'textil-sustentable',
    name: 'Textil Sustentable & Ecológico',
    description: 'Materiales textiles ecológicos y sustentables',
    category: 'textil',
    rating: 4.6,
    reviewCount: 127,
    phone: '+54 11 5678-9012',
    email: 'sustentable@textil.com',
    address: 'Taller en Palermo',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=400&h=300&fit=crop&crop=center',
    services: ['Telas ecológicas', 'Materiales reciclados', 'Producción sustentable'],
    specialties: ['Algodón orgánico', 'Bambú', 'Materiales reciclados'],
    yearsOfExperience: 8,
    certifications: ['Certificación orgánica'],
    isVerified: true,
    isPremium: false,
    responseTime: '48 horas',
    minPrice: '$3.000',
    maxPrice: '$80.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Mercado Pago'],
    workingHours: {
      monday: '8:00 - 17:00',
      tuesday: '8:00 - 17:00',
      wednesday: '8:00 - 17:00',
      thursday: '8:00 - 17:00',
      friday: '8:00 - 17:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'textil-industrial',
    name: 'Textil Industrial & Técnico',
    description: 'Telas técnicas e industriales para uso profesional',
    category: 'textil',
    rating: 4.4,
    reviewCount: 89,
    phone: '+54 11 6789-0123',
    email: 'industrial@textil.com',
    address: 'Depósito en Avellaneda',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop&crop=center',
    services: ['Telas técnicas', 'Materiales industriales', 'Telas resistentes'],
    specialties: ['Lona resistente', 'Telas impermeables', 'Materiales ignífugos'],
    yearsOfExperience: 12,
    certifications: ['Certificación industrial'],
    isVerified: true,
    isPremium: false,
    responseTime: '24 horas',
    minPrice: '$2.000',
    maxPrice: '$50.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 16:00',
      tuesday: '7:00 - 16:00',
      wednesday: '7:00 - 16:00',
      thursday: '7:00 - 16:00',
      friday: '7:00 - 16:00',
      saturday: '7:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  // Proveedores para categoría MAQUINARIA
  {
    id: 'maquinaria-pesada',
    name: 'Maquinaria Pesada & Construcción',
    description: 'Alquiler y venta de maquinaria pesada para construcción',
    category: 'maquinaria',
    rating: 4.7,
    reviewCount: 234,
    phone: '+54 11 7890-1234',
    email: 'pesada@maquinaria.com',
    website: 'https://maquinariapesada.com',
    address: 'Depósito en Pilar',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop&crop=center',
    services: ['Alquiler de maquinaria', 'Venta de equipos', 'Mantenimiento'],
    specialties: ['Excavadoras', 'Retroexcavadoras', 'Grúas móviles'],
    yearsOfExperience: 20,
    certifications: ['Certificación de seguridad'],
    isVerified: true,
    isPremium: true,
    responseTime: '4 horas',
    minPrice: '$50.000',
    maxPrice: '$2.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '6:00 - 18:00',
      tuesday: '6:00 - 18:00',
      wednesday: '6:00 - 18:00',
      thursday: '6:00 - 18:00',
      friday: '6:00 - 18:00',
      saturday: '6:00 - 14:00',
      sunday: 'Emergencias'
    }
  },
  {
    id: 'maquinaria-agricola',
    name: 'Maquinaria Agrícola & Rural',
    description: 'Equipos agrícolas y maquinaria para el campo',
    category: 'maquinaria',
    rating: 4.5,
    reviewCount: 156,
    phone: '+54 11 8901-2345',
    email: 'agricola@maquinaria.com',
    address: 'Depósito en San Antonio de Areco',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=400&h=300&fit=crop&crop=center',
    services: ['Tractores', 'Sembradoras', 'Cosechadoras'],
    specialties: ['Maquinaria agrícola', 'Equipos de riego', 'Herramientas rurales'],
    yearsOfExperience: 25,
    certifications: ['Certificación agrícola'],
    isVerified: true,
    isPremium: false,
    responseTime: '8 horas',
    minPrice: '$30.000',
    maxPrice: '$1.500.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '7:00 - 17:00',
      tuesday: '7:00 - 17:00',
      wednesday: '7:00 - 17:00',
      thursday: '7:00 - 17:00',
      friday: '7:00 - 17:00',
      saturday: '7:00 - 13:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'maquinaria-industrial',
    name: 'Maquinaria Industrial & Manufactura',
    description: 'Equipos industriales y de manufactura',
    category: 'maquinaria',
    rating: 4.6,
    reviewCount: 178,
    phone: '+54 11 9012-3456',
    email: 'industrial@maquinaria.com',
    address: 'Planta en Zárate',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&crop=center',
    services: ['Maquinaria industrial', 'Equipos de producción', 'Automatización'],
    specialties: ['CNC', 'Robótica industrial', 'Sistemas automatizados'],
    yearsOfExperience: 18,
    certifications: ['Certificación industrial'],
    isVerified: true,
    isPremium: true,
    responseTime: '6 horas',
    minPrice: '$100.000',
    maxPrice: '$5.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés', 'Alemán'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  // Proveedores para categoría GESTORES
  {
    id: 'gestores-administrativos',
    name: 'Gestores Administrativos & Legales',
    description: 'Gestión administrativa y trámites legales',
    category: 'gestores',
    rating: 4.8,
    reviewCount: 312,
    phone: '+54 11 0123-4567',
    email: 'admin@gestores.com',
    website: 'https://gestoresadmin.com',
    address: 'Oficina en Microcentro',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop&crop=center',
    services: ['Trámites administrativos', 'Gestión legal', 'Consultoría'],
    specialties: ['Inscripciones', 'Licencias comerciales', 'Certificaciones'],
    yearsOfExperience: 22,
    certifications: ['Gestor matriculado'],
    isVerified: true,
    isPremium: true,
    responseTime: '2 horas',
    minPrice: '$5.000',
    maxPrice: '$200.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 17:00',
      tuesday: '9:00 - 17:00',
      wednesday: '9:00 - 17:00',
      thursday: '9:00 - 17:00',
      friday: '9:00 - 17:00',
      saturday: '9:00 - 13:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'gestores-construccion',
    name: 'Gestores de Construcción & Obras',
    description: 'Gestión de trámites para construcción y obras',
    category: 'gestores',
    rating: 4.6,
    reviewCount: 198,
    phone: '+54 11 1234-5678',
    email: 'construccion@gestores.com',
    address: 'Oficina en Palermo',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop&crop=center',
    services: ['Licencias de obra', 'Habilitaciones', 'Certificaciones'],
    specialties: ['Permisos de construcción', 'Inspecciones', 'Documentación técnica'],
    yearsOfExperience: 15,
    certifications: ['Gestor de construcción'],
    isVerified: true,
    isPremium: false,
    responseTime: '4 horas',
    minPrice: '$8.000',
    maxPrice: '$150.000',
    availability: 'available',
    languages: ['Español'],
    paymentMethods: ['Efectivo', 'Transferencia'],
    workingHours: {
      monday: '8:00 - 16:00',
      tuesday: '8:00 - 16:00',
      wednesday: '8:00 - 16:00',
      thursday: '8:00 - 16:00',
      friday: '8:00 - 16:00',
      saturday: '8:00 - 12:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'gestores-comerciales',
    name: 'Gestores Comerciales & Empresariales',
    description: 'Gestión de trámites comerciales y empresariales',
    category: 'gestores',
    rating: 4.7,
    reviewCount: 245,
    phone: '+54 11 2345-6789',
    email: 'comercial@gestores.com',
    address: 'Oficina en Recoleta',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=300&fit=crop&crop=center',
    services: ['Inscripciones comerciales', 'Habilitaciones', 'Certificaciones'],
    specialties: ['Sociedades', 'Marcas comerciales', 'Patentes'],
    yearsOfExperience: 18,
    certifications: ['Gestor comercial'],
    isVerified: true,
    isPremium: true,
    responseTime: '3 horas',
    minPrice: '$10.000',
    maxPrice: '$300.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '9:00 - 18:00',
      tuesday: '9:00 - 18:00',
      wednesday: '9:00 - 18:00',
      thursday: '9:00 - 18:00',
      friday: '9:00 - 18:00',
      saturday: '9:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  // Proveedores para categoría CONSTRUCTORAS
  {
    id: 'constructora-residencial',
    name: 'Constructora Residencial & Viviendas',
    description: 'Construcción de viviendas y edificios residenciales',
    category: 'constructoras',
    rating: 4.8,
    reviewCount: 456,
    phone: '+54 11 3456-7890',
    email: 'residencial@constructora.com',
    website: 'https://constructoraresidencial.com',
    address: 'Oficina en Belgrano',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop&crop=center',
    services: ['Construcción residencial', 'Edificios', 'Casas particulares'],
    specialties: ['Viviendas unifamiliares', 'Edificios de departamentos', 'Remodelaciones'],
    yearsOfExperience: 30,
    certifications: ['Constructora habilitada'],
    isVerified: true,
    isPremium: true,
    responseTime: '24 horas',
    minPrice: '$500.000',
    maxPrice: '$50.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'constructora-comercial',
    name: 'Constructora Comercial & Industrial',
    description: 'Construcción de edificios comerciales e industriales',
    category: 'constructoras',
    rating: 4.7,
    reviewCount: 334,
    phone: '+54 11 4567-8901',
    email: 'comercial@constructora.com',
    address: 'Oficina en Puerto Madero',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
    services: ['Construcción comercial', 'Edificios industriales', 'Oficinas'],
    specialties: ['Centros comerciales', 'Naves industriales', 'Edificios corporativos'],
    yearsOfExperience: 25,
    certifications: ['Constructora habilitada'],
    isVerified: true,
    isPremium: true,
    responseTime: '48 horas',
    minPrice: '$1.000.000',
    maxPrice: '$200.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '8:00 - 18:00',
      tuesday: '8:00 - 18:00',
      wednesday: '8:00 - 18:00',
      thursday: '8:00 - 18:00',
      friday: '8:00 - 18:00',
      saturday: '8:00 - 14:00',
      sunday: 'Cerrado'
    }
  },
  {
    id: 'constructora-infraestructura',
    name: 'Constructora de Infraestructura & Obras Públicas',
    description: 'Construcción de infraestructura y obras públicas',
    category: 'constructoras',
    rating: 4.9,
    reviewCount: 289,
    phone: '+54 11 5678-9012',
    email: 'infraestructura@constructora.com',
    address: 'Oficina en San Isidro',
    city: 'Buenos Aires',
    province: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop&crop=center',
    services: ['Infraestructura', 'Obras públicas', 'Puentes y caminos'],
    specialties: ['Carreteras', 'Puentes', 'Túneles', 'Aeropuertos'],
    yearsOfExperience: 35,
    certifications: ['Constructora habilitada'],
    isVerified: true,
    isPremium: true,
    responseTime: '72 horas',
    minPrice: '$5.000.000',
    maxPrice: '$1.000.000.000',
    availability: 'available',
    languages: ['Español', 'Inglés', 'Francés'],
    paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta'],
    workingHours: {
      monday: '7:00 - 19:00',
      tuesday: '7:00 - 19:00',
      wednesday: '7:00 - 19:00',
      thursday: '7:00 - 19:00',
      friday: '7:00 - 19:00',
      saturday: '7:00 - 15:00',
      sunday: 'Cerrado'
    }
  }
];

// ===== NUEVO DASHBOARD MODERNO =====

export interface ModernDashboardUser {
  id: string;
  name: string;
  avatar: string;
  department: string;
  isStarred?: boolean;
}

export interface ModernDashboardStat {
  date: string;
  value: number;
  isHighlighted?: boolean;
}

export interface ModernDashboardSecurityUpdate {
  id: string;
  date: string;
  subject: string;
  environment: string;
  action: 'Actualizado' | 'Acceso Temporal' | 'Permiso Actualizado' | 'Aprobado';
  user: {
    name: string;
    avatar: string;
  };
}

export interface ModernDashboardActivity {
  id: string;
  type: 'login' | 'update' | 'password';
  date: string;
  time: string;
  description: string;
  user?: string;
}

export const modernDashboardUsers: ModernDashboardUser[] = [
  {
    id: '1',
    name: 'Helen K.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    department: 'HR',
    isStarred: true
  },
  {
    id: '2',
    name: 'Jessica T.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    department: 'HR',
    isStarred: true
  },
  {
    id: '3',
    name: 'Michael R.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
    department: 'HR',
    isStarred: true
  },
  {
    id: '4',
    name: 'Sarah L.',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face',
    department: 'HR',
    isStarred: true
  }
];

export const modernDashboardStats: ModernDashboardStat[] = [
  { date: '03', value: 280 },
  { date: '04', value: 351 },
  { date: '05', value: 245 },
  { date: '06', value: 320 },
  { date: '07', value: 300 },
  { date: '08', value: 148, isHighlighted: true },
  { date: '09', value: 275 },
  { date: '10', value: 290 }
];

export const modernDashboardSecurityUpdates: ModernDashboardSecurityUpdate[] = [
  {
    id: '1',
    date: '23 Ene, 2020',
    subject: 'AADAMS',
    environment: 'RRHH - Producción',
    action: 'Actualizado',
    user: {
      name: 'Juan Pérez',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face'
    }
  },
  {
    id: '2',
    date: '22 Ene, 2020',
    subject: 'BROWN',
    environment: 'RRHH - Producción',
    action: 'Acceso Temporal',
    user: {
      name: 'María García',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop&crop=face'
    }
  },
  {
    id: '3',
    date: '21 Ene, 2020',
    subject: 'CARTER',
    environment: 'RRHH - Producción',
    action: 'Permiso Actualizado',
    user: {
      name: 'Miguel Rodríguez',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop&crop=face'
    }
  },
  {
    id: '4',
    date: '20 Ene, 2020',
    subject: 'DAVIS',
    environment: 'RRHH - Producción',
    action: 'Aprobado',
    user: {
      name: 'Laura Martínez',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop&crop=face'
    }
  }
];

export const modernDashboardActivities: ModernDashboardActivity[] = [
  {
    id: '1',
    type: 'login',
    date: '26/08',
    time: '23:52',
    description: 'Último acceso'
  },
  {
    id: '2',
    type: 'update',
    date: '23/12',
    time: '11:52',
    description: 'Actualizado'
  },
  {
    id: '3',
    type: 'password',
    date: '26/08',
    time: '10:52',
    description: 'Contraseña cambiada'
  }
];

export const modernDashboardNavigation = [
  { id: 'home', label: 'Inicio', icon: 'fas fa-th-large', href: '/dashboard' },
  { id: 'user-central', label: 'Centro de Usuarios', icon: 'fas fa-user', href: '/dashboard/users' },
  { id: 'access-requests', label: 'Solicitudes de Acceso', icon: 'fas fa-key', href: '/dashboard/access', isActive: true },
  { id: 'admin', label: 'Administración', icon: 'fas fa-wrench', href: '/dashboard/admin' },
  { id: 'settings', label: 'Configuración', icon: 'fas fa-cog', href: '/dashboard/settings' },
  { id: 'support', label: 'Soporte', icon: 'fas fa-bullhorn', href: '/dashboard/support' },
  { id: 'quit', label: 'Salir', icon: 'fas fa-power-off', href: '/logout' }
];

export const modernDashboardDepartments = [
  { id: 'hr', label: 'RRHH', isActive: true },
  { id: 'fs', label: 'FS', isActive: false },
  { id: 'cs', label: 'CS', isActive: false }
];

// Datos mock para el Centro de Usuario
export const userCenterProfile: UserCenterProfile = {
  // Información básica de la empresa
  razonSocial: 'Constructora BuenAire S.A.',
  nombreFantasia: 'BuenAire Construcciones',
  avatar: '/assets/img/logo_buenaire.png',
  
  // Información de contacto
  ddn: '11',
  telefono1: '4567-8901',
  telefono2: '4567-8902',
  email: 'admin@buenaire.com',
  sitioWeb: 'https://www.buenaire.com',
  
  // Información de ubicación
  direccion: 'Av. Corrientes 1234',
  pais: 'Argentina',
  provincia: 'Buenos Aires',
  localidad: 'Ciudad Autónoma de Buenos Aires',
  codigoPostal: '1043',
  
  // Información comercial
  tipoActividad: 'Construcción',
  descripcion: 'Empresa especializada en construcción y remodelación de viviendas y edificios comerciales.',
  rubros: 'Construcción residencial, Construcción comercial, Remodelaciones',
  marcas: 'Durlock, Klaukol, Ferrum',
  
  // Información de contacto principal
  contacto: 'Juan Pérez',
  
  // Información de cuenta
  usuario: 'buenaire_admin',
  fechaRegistro: '15/01/2024',
  estadoCuenta: 'activa',
  planActual: 'Premium',
  
  // Configuraciones adicionales
  notificacionesEmail: true,
  notificacionesSMS: false,
  newsletter: true,
};

export const userCenterNavigation = [
  {
    id: 'profile',
    label: 'Perfil de Empresa',
    icon: 'fas fa-building',
    href: '/dashboard'
  },
  {
    id: 'security',
    label: 'Seguridad',
    icon: 'fas fa-shield-alt',
    href: '/user-center/security'
  },
  {
    id: 'notifications',
    label: 'Notificaciones',
    icon: 'fas fa-bell',
    href: '/user-center/notifications'
  },
  {
    id: 'billing',
    label: 'Facturación',
    icon: 'fas fa-credit-card',
    href: '/user-center/billing'
  },
  {
    id: 'activity',
    label: 'Actividad',
    icon: 'fas fa-chart-line',
    href: '/user-center/activity'
  }
];


